import { getFirstFocusCandidate as e, getTabbableElements as t } from "./focustrap-utils.js";
import { FOCUSTRAP_DEFAULTS as n, FOCUSTRAP_STATE_KEY as r } from "./focustrap-constants.js";
//#region directives/focustrap_directive/focustrap.js
var i = {
	name: "dt-focustrap-directive",
	install(e) {
		e.directive("dt-focustrap", {
			mounted(e, t) {
				let n = a(t.value);
				e[r] = o(), n.active && s(e, n);
			},
			updated(e, t) {
				let n = a(t.oldValue), i = a(t.value);
				e[r] && (!n.active && i.active ? s(e, i) : n.active && !i.active && c(e));
			},
			unmounted(e) {
				e[r]?.active && c(e), l(e), delete e[r];
			}
		});
	}
};
function a(e) {
	return e == null || e === !0 ? {
		...n,
		active: !0
	} : e === !1 ? {
		...n,
		active: !1
	} : typeof e == "object" ? {
		...n,
		...e
	} : {
		...n,
		active: !!e
	};
}
function o() {
	return {
		active: !1,
		onKeydown: null,
		previousActiveElement: null,
		restoreFocus: !0,
		addedTabindex: !1
	};
}
function s(e, t) {
	let n = e[r];
	!n || n.active || (n.active = !0, n.restoreFocus = t.restoreFocus, n.previousActiveElement = document.activeElement, n.onKeydown = (t) => p(t, e), e.addEventListener("keydown", n.onKeydown), f(e, t));
}
function c(e) {
	let t = e[r];
	if (!(!t || !t.active)) {
		if (t.active = !1, l(e), t.restoreFocus && t.previousActiveElement) try {
			t.previousActiveElement.focus({ preventScroll: !0 });
		} catch {}
		t.previousActiveElement = null;
	}
}
function l(e) {
	let t = e[r];
	t && (t.onKeydown && (e.removeEventListener("keydown", t.onKeydown), t.onKeydown = null), t.addedTabindex && (e.removeAttribute("tabindex"), t.addedTabindex = !1));
}
function u(n, r) {
	return r === "auto" || r == null ? e(t(n, { includeNegativeTabIndex: !0 })) : typeof r == "string" ? n.querySelector(r) : r instanceof HTMLElement ? r : null;
}
function d(e, t) {
	if (t) {
		t.focus({ preventScroll: !0 });
		return;
	}
	if (!e.hasAttribute("tabindex")) {
		e.setAttribute("tabindex", "-1");
		let t = e[r];
		t && (t.addedTabindex = !0);
	}
	e.focus({ preventScroll: !0 });
}
function f(e, t) {
	t.initialFocus !== !1 && Promise.resolve().then(() => {
		e[r]?.active && d(e, u(e, t.initialFocus));
	});
}
function p(e, n) {
	if (e.key !== "Tab") return;
	let r = t(n);
	if (!r.length) {
		e.preventDefault();
		return;
	}
	let i = r[0], a = r[r.length - 1];
	e.shiftKey ? document.activeElement === i && (a.focus({ preventScroll: !0 }), e.preventDefault()) : document.activeElement === a && (i.focus({ preventScroll: !0 }), e.preventDefault());
}
//#endregion
export { i as DtFocustrapDirective, i as default };

//# sourceMappingURL=focustrap.js.map